'use strict';
import news from './news';

const tint = {
    twiter: new Array(),
    instagram: new Array(),
    linkedin: new Array(),
    youtube: new Array(),
    fullUrl: tint_json['ajaxurl'],
    init: function () {
        // if(document.querySelector('.home') || document.querySelector('.page-template-tpl-actualites') || document.querySelector('.tax-theme-article') ) {
        if (document.querySelector('.home') || document.querySelector('.tax-theme-article')) {
            tint.loadJson();
            tint.events();
        }
        if (document.querySelector('.single-realisation')) {
            tint.events();
        }
    },
    events: function () {
        var elts = document.querySelectorAll('.card[data-link]');
        elts.forEach((item) => {
            item.addEventListener('click', function () {
                window.open(this.dataset.link);
            })
        })
    },
    loadJson: function () {
        let request = new XMLHttpRequest();
        request.open("GET", tint.fullUrl);
        request.onreadystatechange = function () {
            if (request.readyState == 4 && request.status == 200) {
                let data = JSON.parse(request.responseText);
                data.forEach(element => {
                    if (element.network == "twitter") {
                        if (element.text != "")
                            tint.twiter.push(element);
                    }
                    else if (element.network == "instagram_business") {
                        if (element.media['1024'] != "")
                            tint.instagram.push(element);
                    }
                    else if (element.network == "linkedin") {
                        if (element.text != "")
                            tint.linkedin.push(element);
                    }
                    else if (element.network == "youtube") {
                        tint.youtube.push(element);
                    }
                });
                if (document.querySelector('.home'))
                    tint.homeRS();
                // if (document.querySelector('.page-template-tpl-actualites') || document.querySelector('.tax-theme-article'))
                /*   if (document.querySelector('.tax-theme-article'))
                       tint.actuRS();*/
            }
        };
        request.send();
    },
    homeRS: function () {
        let itemtwiter = 0;
        let iteminstagram = 0;
        let itemlinkedin = 0;
        let listItem = document.querySelectorAll('.social_item');
        let cesure = 600;
        if (window.matchMedia("(max-width: 767px)").matches) {
            cesure = 190
        }
        else if (window.matchMedia("(max-width: 1099px)").matches) {
            cesure = 170
        }
        else if (window.matchMedia("(max-width: 1300px)").matches) {
            cesure = 80
        }
        else if (window.matchMedia("(max-width: 1500px)").matches) {
            cesure = 150
        }
        else if (window.matchMedia("(max-width: 1700px)").matches) {
            cesure = 230
        }
        //Creation markup
        listItem.forEach(element => {
            if (element.classList.contains('twitter')) {
                if (tint.twiter[itemtwiter]) {
                    element.dataset.url = tint.twiter[itemtwiter].url;
                    var textContent = tint.twiter[itemtwiter].text.replace(/<([^>])*>/g, '');
                    textContent = textContent.substr(0, cesure)
                    element.innerHTML = '<div class="twitter_wrap"><div class="twitter_head"><a href="#" target="blank" class="twitter_picto"></a><div><div class="twitter_blaz"><a href="#" target="blank">' + tint.twiter[itemtwiter].author + '</a></div><div class="twitter_time">' + tint.twiter[itemtwiter].date + '</div></div></div><div class="twitter_body">' + textContent + '...</div></div>';
                    itemtwiter++;
                }
            }
            else if (element.classList.contains('instagram_business')) {
                if (tint.instagram[iteminstagram]) {
                    element.dataset.url = tint.instagram[iteminstagram].url;
                    element.innerHTML = '<div class="instagram_wrap"><a href="#" class="instagram_media"><img src="' + tint.instagram[iteminstagram].media['1024'] + '" alt=""></a></div>';
                    iteminstagram++;
                }
            }
            else if (element.classList.contains('linkedin')) {
                if (tint.linkedin[itemlinkedin]) {
                    element.dataset.url = tint.linkedin[itemlinkedin].url;

                    var textContent = tint.linkedin[itemlinkedin].text.replace(/<([^>])*>/g, '');
                    textContent = textContent.substr(0, cesure)
                    element.innerHTML = '<div class="linkedin_wrap"><div class="linkedin_head"><a href="#" target="blank" class="linkedin_picto"></a><div><div class="linkedin_blaz"><a href="#" target="blank">' + tint.linkedin[itemlinkedin].author + '</a></div><div class="linkedin_time">' + tint.linkedin[itemlinkedin].date + '</div></div></div><div class="linkedin_body">' + textContent + '...</div></div>'
                    itemlinkedin++;
                }
            }
            //Evenement au click sur chaque bloc
            element.addEventListener('click', function () {
                window.open(element.dataset.url);
            });
        });
    },
    actuRS: function () {
        let isoNews = news.layoutRS();
        let itemtwiter = 0;
        let iteminstagram = 0;
        let itemlinkedin = 0;
        let itemyoutube = 0;
        let listItem = document.querySelectorAll('.news_rs .news_item');
        //Creation markup
        listItem.forEach(element => {
            if (element.querySelector('.card') && element.querySelector('.card').classList.contains('twitter')) {
                if (tint.twiter[itemtwiter]) {
                    element.dataset.url = tint.twiter[itemtwiter].url;
                    element.querySelector('.card').innerHTML = '<div class="twitter_head"><a href="#" target="blank" class="twitter_picto"></a><div class="twitter_blaz"><a href="#" target="blank">' + tint.twiter[itemtwiter].author + '</a></div><div class="twitter_time">' + tint.twiter[itemtwiter].date + '</div></div><div class="twitter_body">' + tint.twiter[itemtwiter].text + '</div><a class="twitter_media" href="' + tint.twiter[itemtwiter].url + '" target="blank"><img src="' + tint.twiter[itemtwiter].media['1024'] + '" alt=""></a>';
                    itemtwiter++;
                }
            }
            else if (element.querySelector('.card') && element.querySelector('.card').classList.contains('instagram_business')) {
                if (tint.instagram[iteminstagram]) {
                    element.dataset.url = tint.instagram[iteminstagram].url;
                    element.querySelector('.card').innerHTML = '<a href="#" class="instagram_media"><img src="' + tint.instagram[iteminstagram].media['1024'] + '" alt=""></a>';
                    iteminstagram++;
                }
            }
            else if (element.querySelector('.card') && element.querySelector('.card').classList.contains('linkedin')) {
                if (tint.linkedin[itemlinkedin]) {
                    element.dataset.url = tint.linkedin[itemlinkedin].url;
                    element.querySelector('.card').innerHTML = '<div class="linkedin_head"><a href="#" target="blank" class="linkedin_picto"></a><div><div class="linkedin_blaz"><a href="#" target="blank">' + tint.linkedin[itemlinkedin].author + '</a></div><div class="linkedin_time">' + tint.linkedin[itemlinkedin].date + '</div></div></div><div class="linkedin_body">' + tint.linkedin[itemlinkedin].text + '</div>'
                    itemlinkedin++;
                }
            }
            else if (element.querySelector('.card') && element.querySelector('.card').classList.contains('bVideo')) {
                if (tint.youtube[itemyoutube]) {

                    var idYT = tint.youtube[itemyoutube].url.split(/v\/|v=|youtu\.be\//)[1].split(/[?&]/)[0];
                    element.querySelector('.card').innerHTML = '<div class="bVideo_media"><div id="' + idYT + '" class="bVideo_video video-notallowed"></div><img src="' + tint.youtube[itemyoutube].media['1024'] + '" class="bVideo_poster" alt=""><button class="btn_play"></button><button class="stopVideo"></button><h3 class="bVideo_title">' + tint.youtube[itemyoutube].text + '</h3></div>';
                }
                itemyoutube++;
            }

            if (element.querySelector('.card') && !element.querySelector('.card').classList.contains('bVideo')) {
                //Evenement au click sur chaque bloc
                element.addEventListener('click', function (e) {
                    e.preventDefault();
                    window.open(element.dataset.url);
                });
            }
            else if (element.querySelector('.card') && element.querySelector('.card').classList.contains('bVideo')) {
                if (element.querySelector('.bVideo_video')) {
                    element.addEventListener('click', function (e) {
                        let id = element.querySelector('.bVideo_video').id;
                        document.querySelector('.bVideo_popin .bVideo_popin-content').innerHTML = '<iframe frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" title="YouTube video player" width="100%" height="100%" src="https://www.youtube.com/embed/' + id + '?rel=0&amp;showinfo=0&amp;controls=1&amp;enablejsapi=1&amp;widgetid=2&amp;autoplay=1"></iframe>';
                        document.querySelector('.bVideo_popin').classList.add('visible');
                    });
                }
            }
            var timer = setTimeout(function () {
                isoNews.reloadItems();
                isoNews.layout();
                clearTimeout(timer);
            }, 2000);

        });
    }
};

export default tint;


// WEBPACK FOOTER //
// ./src/scripts/components/tint.js